import React from 'react'
import { Modal, ModalHeader, Button } from 'reactstrap';
import { FormRack } from './FormRack';
import { Dialog } from 'primereact/dialog';

export const ModalRack = (props) => {

    const {
        modal, modalTitle, closeDialog, method, loading,
        name, code, slots, handleInputChange, validaciones,
        saveCreate, saveUpdate
    } = props;

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end"}}>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                disabled={loading}
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                {
                                    method === "create"
                                        ? "Guardando..."
                                        : "Actualizando..."
                                }
                            </>
                        )
                        : (
                            method === "create"
                                ? "Guardar"
                                : "Actualizar"
                        )
                }
            </Button>
            
        </div>
    );

    return (
        <Dialog 
            header={modalTitle} 
            visible={modal} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
            footer={footer}>
            {
                method === "create"
                    ? <FormRack button={"Guardar gradilla"} {...{ loading, handleInputChange, validaciones, methodAction: saveCreate }} />
                    : (method === "update")
                        ? <FormRack button={"Actualizar gradilla"} {...{ loading, handleInputChange, validaciones, methodAction: saveUpdate, name, code, slots }} />
                        : null
            }
        </Dialog>
    )
}
